module.exports = __webpack_public_path__ + "img/login__background.005b98fb.jpg";